import * as React from 'react';
//@ts-ignore
import { BrowserProtocol, queryMiddleware } from 'farce';
import { createFarceRouter, createRender, makeRouteConfig, Route } from 'found';
//@ts-ignore
import { Resolver } from 'found-relay';
import environment from './api/environment';
import { graphql, createFragmentContainer } from 'react-relay';
import { ThemeProvider } from 'react-jss';
import theme from './helpers/theme';
import AppHolder from 'views/AppHolder';
import { Redirect } from 'react-router-dom';
import Home from 'views/Home';
import AboutUs from 'views/AboutUs';
import RegisterStart from 'views/RegisterStart';
import RegisterIndividual from 'views/RegisterIndividual';
import RegisterCompany from 'views/RegisterCompany';
import Courses from 'views/Courses';
import Consultancy from 'views/Consultancy';
import CourseDetailsPage from 'views/CourseDetailsPage';
import ContactUs from 'views/ContactUs';
import RegisterCalendar from 'views/RegisterCalendar';
import ArticleLandingPage from 'views/ArticleLandingPage';
import Article from 'views/Article';
import CompanyFeatures from 'views/CompanyFeatures';
import IndividualFeatures from 'views/IndividualFeatures';
import ExploreCourses from 'views/ExploreCourses';
import ContentsPage from 'views/Policies/ContentsPage';
import moment from 'moment';

const Router = createFarceRouter({
  historyProtocol: new BrowserProtocol(),
  historyMiddlewares: [queryMiddleware],
  routeConfig: makeRouteConfig(
    <Route>
      <Route path="/" Component={RegisterStart} />
      <Route path="/register/individual" Component={RegisterIndividual} />
      <Route path="/register/company" Component={RegisterCompany} />
      <Route path="/register/calendar" Component={RegisterCalendar} />
    </Route>,
  ),
  render: createRender({}),
});

const App = () => (
  <ThemeProvider theme={theme}>
    <Router resolver={new Resolver(environment)} />
  </ThemeProvider>
);

export default App;
